import { createTransform } from 'redux-persist';

import {
  isDeletedLinkData,
  isDeletedNodeData,
} from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const pruneDeletedProjectModels = createTransform<
  ReduxState['projects'],
  ProjectsState,
  ReduxState
>(
  (projectsState) => {
    const prunedProjectsById: Record<string, Project> = {};
    projectsState.projectIds.forEach((id) => {
      const project = projectsState.projectsById[id];
      if (!project) {
        return;
      }

      const { deletedModelIds, ...modelData } = project.diagram.model.modelData;

      const modelsById = { ...project.modelsById };
      Object.keys(modelsById).forEach((modelId) => {
        if (deletedModelIds?.includes(modelId)) {
          delete modelsById[modelId];
        }
      });

      const isDraft = Boolean(project.diagram.model.modelData.draftData);
      const nodeDataArray = isDraft
        ? project.diagram.model.nodeDataArray
        : project.diagram.model.nodeDataArray.filter(
            (data) => !isDeletedNodeData(data)
          );
      const linkDataArray = isDraft
        ? project.diagram.model.linkDataArray
        : project.diagram.model.linkDataArray.filter(
            (data) => !isDeletedLinkData(data)
          );

      prunedProjectsById[project.id] = {
        ...project,
        diagram: {
          ...project.diagram,
          model: {
            ...project.diagram.model,
            nodeDataArray,
            linkDataArray,
            modelData,
          },
        },
        modelsById,
      };
    });

    return { ...projectsState, projectsById: prunedProjectsById };
  },
  null,
  { whitelist: ['projects'] }
);
